// import React, { useEffect, useState } from 'react'
// import ProgramManagerPartnerAssociationGrid from './ProgramManagerPartnerAssociationGrid'
// import api from '../../utils/api'
// import { toast } from 'react-toastify'
// import { ControlledInput } from '../../common/Input/Input'
// import Select from 'react-select'
// import Spinner from '../../common/Spinner/Spinner'

// const ProgramManagerPartnerAssociationHome = () => {

//     const [tableData, setTableData] = useState([])
//     const [id, setId] = useState('')

//     const [partnerName, setPartnerName] = useState('')
//     const [loading, setLoading] = useState(false)

//     const [programManagerList, setProgramManagerList] = useState([])
//     const [selectedProgramManagerName, setSelectedProgramManagerName] = useState()

//     const [isEditClicked, setIsEditClicked] = useState(false)
//     const [isAddClicked, setIsAddClicked] = useState(false)

//     useEffect(() => {
//         fetchTableData()
//         fetchAllProgramManagersList()
//     }, [])

//     const fetchTableData = () => {
//         setLoading(true)
//         const { tempGetAllProgramManagerPartnerList } = api.getAllProgramManagerPartnerData()
//             .then(({ data }) => {
//                 setLoading(false)
//                 console.log("table data", data)
//                 setTableData(data)
//             })
//     }

//     const fetchAllProgramManagersList = () => {
//         const { tempGetAllProgramManagers } = api.getAllProgramManagerData()
//             .then(({ data }) => {
//                 const options = data
//                     .filter(item => item.sProgramManager !== "" && item.sProgramManager !== null)
//                     .map(item => ({
//                         label: item.sProgramManager,
//                         value: item.sProgramManager,
//                     }));
//                 console.log("Program", options);
//                 setProgramManagerList(options)
//             })
//     }

//     const onProgramManagerChange = (option) => {
//         setSelectedProgramManagerName(option)
//     }

//     const handleChange = (e) => {
//         setPartnerName(e.target.value)
//     }

//     const editAssociation = (ele) => {
//         setPartnerName(ele.sEntryPoint)
//         const programManagerOption = {
//             value: ele.sProgramManager,
//             label: ele.sProgramManager
//         }
//         setSelectedProgramManagerName(programManagerOption)
//         setId(ele.Id)
//         setIsEditClicked(true)
//     }

//     const onEditSaveBtnClick = () => {
//         let payload = {
//             sProgramManager: selectedProgramManagerName?.value
//         }

//         const { tempUpdateProgramManagerPartnerAssociation } = api.updateProgramManagerPartnerAssociation(payload, id)
//             .then(({ data }) => {
//                 toast("Updated Successfully.", {
//                     autoClose: 5000,
//                     type: toast.TYPE.SUCCESS,
//                 })
//                 fetchTableData()
//                 setIsEditClicked(false)
//             })
//     }

//     const onEditProgramManager = (manager, data) => {
//         console.log("Data", data.Id)
//         let payload = {
//             sProgramManager: manager
//         }
//         setLoading(true)
//         const { tempUpdateProgramManagerPartnerAssociation } = api.updateProgramManagerPartnerAssociation(payload, data.Id)
//             .then(({ data }) => {
//                 toast("Updated Successfully.", {
//                     autoClose: 5000,
//                     type: toast.TYPE.SUCCESS,
//                 })
//                 setLoading(false)
//             })
//     }

//     const onAddSaveBtnClick = () => {
//         if (!partnerName) {
//             toast("Partner name is Required.", {
//                 autoClose: 5000,
//                 type: toast.TYPE.ERROR,
//             })
//         } else if (!selectedProgramManagerName) {
//             toast("Program manager is Required.", {
//                 autoClose: 5000,
//                 type: toast.TYPE.ERROR,
//             })
//         } else {
//             let payload = {
//                 sProgramManager: selectedProgramManagerName?.value,
//                 sEntryPoint: partnerName
//             }
//             setLoading(true)
//             const { tempAddProgramManagerPartnerAssociation } = api.addProgramManagerPartnerAssociation(payload)
//                 .then(({ data }) => {
//                     toast("Added Successfully.", {
//                         autoClose: 5000,
//                         type: toast.TYPE.SUCCESS,
//                     })
//                     setLoading(false)
//                     fetchTableData()
//                     setIsAddClicked(false)
//                 })
//                 .catch((error) => {
//                     if (error.response.data.detail !== "Authentication credentials were not provided.") {
//                         setLoading(false)
//                         toast(String(error.response.data.message), {
//                             autoClose: 5000,
//                             type: toast.TYPE.ERROR,
//                         });
//                     } else if (error.response.data.message) {
//                         setLoading(false)
//                         toast(String(error.response.data.message), {
//                             autoClose: 5000,
//                             type: toast.TYPE.ERROR,
//                         });
//                     }
//                 })
//         }
//     }

//     const onEditBackClick = () => {
//         setIsEditClicked(false)
//         setPartnerName('')
//         setSelectedProgramManagerName()
//     }

//     const onAddAssociationClick = () => {
//         setIsAddClicked(!isAddClicked)
//     }

//     const onAddBackClick = () => {
//         setIsAddClicked(false)
//         setPartnerName('')
//         setSelectedProgramManagerName()
//     }



//     return (
//         <div className={`${loading && "set-opacity"}`}>
//             {loading && <Spinner className="center-screen" />}
//             <div className="row mt-3">
//                 <div className="col-7"
//                     style={{ display: "flex", alignItems: 'center', justifyContent: 'space-between' }}
//                 >
//                     <label>
//                         <b>Program Manager Partner Association List</b>
//                     </label>

//                     <button className="my-services-model-submit-btn"
//                         onClick={() => onAddAssociationClick()}
//                     >Associate Program Manager</button>


//                 </div>
//             </div>

//             {
//                 isAddClicked &&
//                 <div>
//                     <label>
//                         <b>Add Association</b>
//                     </label>

//                     <div className="row">
//                         <div className="col-3">
//                             <label style={{ marginBottom: "5px" }}>Partner Name <span className="required">*</span></label><br />
//                             <ControlledInput
//                                 name="partnerName"
//                                 placeholder="Partner Name"
//                                 value={partnerName || ""}
//                                 onChange={(text) => handleChange(text)}
//                                 autoComplete="off"
//                             />
//                         </div>

//                         <div className="col-3">
//                             <label style={{ marginBottom: "5px" }}>Program Manager Name <span className="required">*</span></label><br />
//                             <Select
//                                 options={programManagerList}
//                                 onChange={onProgramManagerChange}
//                                 value={selectedProgramManagerName}
//                             />
//                         </div>

//                         <div className="col-3 d-flex align-items-center" style={{ marginTop: '12px' }}>
//                             <button className='my-services-model-submit-btn' onClick={onAddSaveBtnClick}> Save</button>
//                         </div>
//                     </div>
//                 </div>
//             }

//             <div className="row mt-3">
//                 <div className="col-7">
//                     <ProgramManagerPartnerAssociationGrid
//                         programManagerList={programManagerList}
//                         onEditProgramManager={onEditProgramManager}
//                         selectedProgramManagerName={selectedProgramManagerName}
//                         onProgramManagerChange={onProgramManagerChange}
//                         setSelectedProgramManagerName={setSelectedProgramManagerName}
//                         tableData={tableData} editAssociation={editAssociation} />
//                 </div>
//             </div>


//         </div>
//     )
// }

// export default ProgramManagerPartnerAssociationHome



import React, { useEffect, useState } from 'react'
import ProgramManagerPartnerAssociationGrid from './ProgramManagerPartnerAssociationGrid'
import api from '../../utils/api'
import { toast } from 'react-toastify'
import { ControlledInput } from '../../common/Input/Input'
import Select from 'react-select'
import Spinner from '../../common/Spinner/Spinner'

import { DOWNLOAD_API_URL } from '../../utils/constants'

const ProgramManagerPartnerAssociationHome = () => {

    const [tableData, setTableData] = useState([])
    const [id, setId] = useState('')

    const [partnerName, setPartnerName] = useState('')
    const [loading, setLoading] = useState(false)

    const [programManagerList, setProgramManagerList] = useState([])
    const [selectedProgramManagerName, setSelectedProgramManagerName] = useState()
    const [partnernameList, setPartnerNameList] = useState([])
    const [selectedPartnerNameOption, setSelectedPartnerNameOption] = useState([])

    const [isEditClicked, setIsEditClicked] = useState(false)
    const [isAddClicked, setIsAddClicked] = useState(false)

    const [partnerProgramManagerNameData, setPartnerProgramManagerNameData] = useState(null);
    const [searchProgramManagerName, setSearchProgramManagerName] = useState("");

    const[searchByOption, setSearchByOption] = useState(
        [
            {
                label: "Partner Name",
                value: "sEntryPoint"
            },
            {
                label: "Program Manager Name",
                value: "sProgramManager"
            }
        ]
    )
    const [searchByOptionVal, setSearchByOptionVal] = useState("")


    useEffect(() => {
        fetchTableData()
        fetchAllProgramManagersList()
        downloadpartnerProgramName()
    }, [])

    // const fetchTableData = (searchProgramManagerName) => {
    //     setLoading(true)
    //     const { tempGetAllProgramManagerPartnerList } = api.getAllProgramManagerPartnerData({sProgramManager: searchProgramManagerName})
    //         .then(({ data }) => {
    //             setLoading(false)
    //             console.log("table data", data)
    //             setTableData(data)
    //         })
    //         .catch(err=>{
    //             console.log(err, ">>>err in getting programme manager name");
    //             setLoading(false)
    //         })
        
    //     setLoading(false)
    // }

    // my fetch table data
    const fetchTableData = async(searchProgramManagerName) => {
        console.log(searchProgramManagerName, ">>>searchProgramManagerName in fetChTableData in partner association screen")   
        setLoading(true)
        
        try{
            console.log(searchByOptionVal, ">>>SearchOptionVal");

            const {value}= searchByOptionVal;
            console.log(value, ">>>> searchOptionVal ka value");

            let allData;
            const response = await api.getAllProgramManagerPartnerData({searchByVal: value, name: searchProgramManagerName});
            allData = response?.data;


            // allData.sort((a, b) => {
            //     const entryA = a?.sProgramManager?.toLowerCase() || ""; // Default to ""
            //     const entryB = b?.sProgramManager?.toLowerCase() || ""; // Default to ""
            
            //     // Handle empty strings explicitly
            //     if (entryA === "" && entryB !== "") return 1; // Move `entryA` to the end
            //     if (entryB === "" && entryA !== "") return -1; // Move `entryB` to the end
            
            //     // Normal comparison for non-empty values
            //     return entryA.localeCompare(entryB);
            // });
            
            console.log(allData, ">>>all data in partner association api try block after");

            const partnerNameListData = allData.map((item) => {
                return {
                    label: item.sEntryPoint,
                    value: item.Id,
                }
            })

            setTableData(allData)
            setPartnerNameList(partnerNameListData)
            setLoading(false);
        } catch(err){
            console.log(err, ">>>Err in geting searchProgramManagerName in partner association")
            setLoading(false)
        }
        setLoading(false)
    }

    const fetchAllProgramManagersList = () => {
        const { tempGetAllProgramManagers } = api.getAllProgramManagerData()
            .then(({ data }) => {
                const options = data
                    .filter(item => item.sProgramManager !== "" && item.sProgramManager !== null)
                    .map(item => ({
                        label: item.sProgramManager,
                        value: item.sProgramManager,
                    }));
                console.log("Program", options);
                setProgramManagerList(options)
            })
    }

    const onProgramManagerChange = (option) => {
        setSelectedProgramManagerName(option)
    }

    const onPartnerNameChange = (option) => {
        setSelectedPartnerNameOption(option)
    }

    const handleChange = (e) => {
        setPartnerName(e.target.value)
    }

    const editAssociation = (ele) => {
        setPartnerName(ele.sEntryPoint)
        const programManagerOption = {
            value: ele.sProgramManager,
            label: ele.sProgramManager
        }
        setSelectedProgramManagerName(programManagerOption)
        setId(ele.Id)
        setIsEditClicked(true)
    }

    const onEditSaveBtnClick = () => {
        let payload = {
            sProgramManager: selectedProgramManagerName?.value
        }

        const { tempUpdateProgramManagerPartnerAssociation } = api.updateProgramManagerPartnerAssociation(payload, id)
            .then(({ data }) => {
                toast("Updated Successfully.", {
                    autoClose: 5000,
                    type: toast.TYPE.SUCCESS,
                })
                fetchTableData()
                setIsEditClicked(false)
            })
    }

    const onEditProgramManager = (manager, data) => {
        console.log("Data", data.Id)
        let payload = {
            sProgramManager: manager
        }
        setLoading(true)
        const { tempUpdateProgramManagerPartnerAssociation } = api.updateProgramManagerPartnerAssociation(payload, data.Id)
            .then(({ data }) => {
                toast("Updated Successfully.", {
                    autoClose: 5000,
                    type: toast.TYPE.SUCCESS,
                })
                fetchTableData();
                setLoading(false)
            })
    }

    const onAddSaveBtnClick = () => {
        const trimmedPartnerName = selectedPartnerNameOption?.label.trim();
        
        if (!trimmedPartnerName) {
            toast("Partner name is Required.", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            })
        } else if (!selectedProgramManagerName) {
            toast("Program manager is Required.", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            })
        } else {
            let payload = {
                sProgramManager: selectedProgramManagerName?.value,
                // sEntryPoint: trimmedPartnerName
            }
            setLoading(true)
            const { tempAddProgramManagerPartnerAssociation } = api.updateProgramManagerPartnerAssociation(payload, selectedPartnerNameOption?.value )
                .then(({ data }) => {
                    toast("Added Successfully.", {
                        autoClose: 5000,
                        type: toast.TYPE.SUCCESS,
                    })
                    setLoading(false)
                    fetchTableData()
                    setIsAddClicked(false)
                    setPartnerName("");
                })
                .catch((error) => {
                    if (error.response.data.detail !== "Authentication credentials were not provided.") {
                        setLoading(false)
                        toast(String(error.response.data.message), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    } else if (error.response.data.message) {
                        setLoading(false)
                        toast(String(error.response.data.message), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }
                })
        }
    }

    const onEditBackClick = () => {
        setIsEditClicked(false)
        setPartnerName('')
        setSelectedProgramManagerName()
    }

    const onAddAssociationClick = () => {
        setIsAddClicked(!isAddClicked)
    }

    const onAddBackClick = () => {
        setIsAddClicked(false)
        setPartnerName('')
        setSelectedProgramManagerName()
    }

    const onSearchClicked = () =>{
        console.log(">>>>> onSearch clicked in partner association");
        console.log(searchProgramManagerName, ">>>>searchProgramManagerName in partner association screen");
        
        fetchTableData(searchProgramManagerName);
        setSearchProgramManagerName("");
        setSearchByOptionVal("")
    }

    const downloadpartnerProgramName = async() => {
        try{
            let response = await api.getPartnerProgramManagerList()
            let data = response?.data;
            let downloadUrl = data?.generated_file;
            let downloadUrlSplit = downloadUrl?.split("/");
            let fileName = downloadUrlSplit[downloadUrlSplit?.length-1];
            setPartnerProgramManagerNameData(`/${fileName}`)
        } catch(err){
            console.log(err?.message)
        }
    }

    const handleSearchByOptionChange = (option) => {
        console.log(option, ">>>> search by option");
        setSearchByOptionVal(option);
    }

    console.log(programManagerList, ">>>>programManagerList");


    return (
        <div className={`${loading && "set-opacity"}`} style={{backgroundColor:""}}>
            {loading && <Spinner className="center-screen" />}
            <div className="row mt-3">
                {/* Header row for the label */}
                <div className="col-12 text-center mb-2">
                    <div className='col-7'>
                    <label>
                        <b>Program Manager Partner Association List</b>
                    </label>
                    </div>
                </div>

                {/* Row for buttons and search bar */}
                <div className="col-7" style={{
                    display: "flex",
                    alignItems: 'flex-end',
                    justifyContent: 'space-between',
                    backgroundColor: "",
                    padding: "10px",
                    borderRadius: "8px"
                }}>
                    {/* Left Section: Add Partner and Download Buttons */}
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        backgroundColor: "",
                        paddingRight: '10px',
                        paddingLeft:"8px"
                    }}>
                        <button className="my-services-model-submit-btn mr-2"
                            onClick={() => onAddAssociationClick()}
                        >Associate Program Manager</button>

                        <a href={`${DOWNLOAD_API_URL}/static_live/Reports/${partnerProgramManagerNameData}`}>
                            <button className="my-services-model-submit-btn"
                            >Download</button>
                        </a>
                    </div>

                    {/* Right Section: Search Input and Button */}
                    <div className="col-8" style={{backgroundColor:""}}>
                        <div className='row d-flex' style={{justifyContent:"flex-end", flexWrap:"wrap", backgroundColor:""}}>
                        <Select
                                className="col-4"
                                options={searchByOption}
                                onChange={handleSearchByOptionChange}
                                value={searchByOptionVal}
                            />
						<input
							type="text"
							className="conv-float-right form-control conv-h250rem search-input "
							placeholder="Program Manager/Partner Name"
							onChange={(e)=>setSearchProgramManagerName(e.target.value)}
							onKeyPress={(e) => {
								if (e.key === "Enter") {
									onSearchClicked();
                                    setSearchProgramManagerName("")
								}
							}}
							// autoComplete={false}
							value={searchProgramManagerName}
							name="searchTermmmm"
						/>	
                        <button 
                            className="lpm-con-btn-bordered conv-float-right conv-font14 conv-pl15 conv-pr15 con-br0"
                            onClick={onSearchClicked}
                            // disabled={searchByOptionVal ? "" : "disabled"}
                        >
							Search
						</button>
                        </div>
					</div>
                </div>

            </div>

            {
                isAddClicked &&
                <div>
                    <label>
                        <b>Add Association</b>
                    </label>

                    <div className="row">
                        <div className="col-3">
                            <label style={{ marginBottom: "5px" }}>Partner Name <span className="required">*</span></label><br />
                            {/* <ControlledInput
                                name="partnerName"
                                placeholder="Partner Name"
                                value={partnerName || ""}
                                onChange={(text) => handleChange(text)}
                                autoComplete="off"
                            /> */}

                            <Select
                                options={partnernameList}
                                onChange={onPartnerNameChange}
                                value={selectedPartnerNameOption}
                            />
                        </div>

                        <div className="col-3">
                            <label style={{ marginBottom: "5px" }}>Program Manager Name <span className="required">*</span></label><br />
                            <Select
                                options={programManagerList}
                                onChange={onProgramManagerChange}
                                value={selectedProgramManagerName}
                            />
                        </div>

                        <div className="col-3 d-flex align-items-center" style={{ marginTop: '12px' }}>
                            <button className='my-services-model-submit-btn' onClick={onAddSaveBtnClick}> Save</button>
                        </div>
                    </div>
                </div>
            }

            <div className="row mt-3">
                <div className="col-7">
                    <ProgramManagerPartnerAssociationGrid
                        programManagerList={programManagerList}
                        onEditProgramManager={onEditProgramManager}
                        selectedProgramManagerName={selectedProgramManagerName}
                        onProgramManagerChange={onProgramManagerChange}
                        setSelectedProgramManagerName={setSelectedProgramManagerName}
                        tableData={tableData} editAssociation={editAssociation} />
                </div>
            </div>


        </div>
    )
}

export default ProgramManagerPartnerAssociationHome
